"use client"

import { createPortal } from "react-dom"
import { SnackbarRoot, SnackbarTitle, SnackbarWrapper } from "./Styled"
import React, { useEffect, useLayoutEffect, useRef, useState } from "react"
import { ICustomSnackbarInfo } from "features/notification/hooks"
import SuccessIcon from "components/Icons/SuccessIcon"
import { Link } from "react-router-dom"

const INIT_TRANSLATE_Y = -200
const SNACKBAR_OFFSET = 16

export default function CustomSnackbarItem({
  customSnackbarInfo,
  onClose,
}: {
  customSnackbarInfo: ICustomSnackbarInfo
  onClose: () => void
}) {
  const { title, status, link } = customSnackbarInfo
  const [style, setStyle] = useState({
    opacity: 1,
    transform: `translateY(${INIT_TRANSLATE_Y}px)`,
    transitionDelay: "0s, 0s",
  })

  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!ref.current) {
      return
    }

    if (status === "active") {
      // Use setTimeout to ensure the initial state is painted before transitioning
      const timeoutId = setTimeout(() => {
        setStyle({
          opacity: 1,
          transform: `translateY(${SNACKBAR_OFFSET}px)`,
          transitionDelay: "0s, 0s",
        })
      }, 10)

      return () => clearTimeout(timeoutId)
    } else {
      setStyle({
        opacity: 0,
        transform: `translateY(${INIT_TRANSLATE_Y}px)`,
        transitionDelay: "0s, 0.15s",
      })
    }
  }, [customSnackbarInfo, status])

  return (
    <>
      {createPortal(
        <SnackbarRoot
          ref={ref}
          style={
            {
              ...style,
              "--animation-duration-long":
                status === "active" ? "0.275s" : "1s",
            } as React.CSSProperties
          }
        >
          <SnackbarWrapper>
            <SuccessIcon />

            <div>
              <SnackbarTitle>{title}</SnackbarTitle>
              {link && (
                <Link
                  onClick={() => {
                    onClose()
                  }}
                  to={link.src}
                >
                  {link.text}
                </Link>
              )}
            </div>
          </SnackbarWrapper>
        </SnackbarRoot>,
        document.querySelector(".app") as Element,
      )}
    </>
  )
}
